import "../../nexus-client-4D0Jw00_.js";
import { benefit as t } from "../index.js";
const i = t.wishlist, s = i.active;
export {
  s as active,
  i as benefitWishlist
};
/*                             */
